import FallbackComponent from '@components/std-components/FallbackComponent'
import { SelectAllElementProps } from '@components/std-components/SelectComponent/components/SelectAllElement'
import React, { ElementType, FC, lazy, Suspense } from 'react'
import { SettingContentElement } from '../../models/settings'

const SettingsLazy = lazy(() => import('./Settings'))

const Settings: FC<
  SettingContentElement & { selectAllElement?: ElementType<SelectAllElementProps> }
> = props => {
  return (
    <Suspense fallback={<FallbackComponent />}>
      <SettingsLazy {...props} />
    </Suspense>
  )
}

export default Settings
